//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'TimePickerValueSelector',
  props: {
    value: {
      type: Object,
      default: function () {
        return null
      }
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      groupsCount: 5, // использовать нечетное значение !

      innerItems: null,
      lastClickedItem: null
    }
  },
  computed: {
    selectedItem: {
      get: function () {
        return this.value
      },
      set: function (value) {
        return this.$emit('input', value)
      }
    }
  },
  watch: {
    selectedItem: function (selectedItem) {
      // обновляем выбранный элемент (для выделения)
      for (const innerItem of this.innerItems) {
        innerItem.selected = !!(selectedItem && selectedItem.value === innerItem.item.value)
      }

      if (selectedItem && (this.lastClickedItem == null || this.lastClickedItem != selectedItem)) {
        if (!selectedItem.active) {
          this.formInnerItems()
        }
        this.scrollToSelectedItem(selectedItem)
      }
    }
  },
  created: function () {
    this.formInnerItems()
  },
  mounted: function () {
    this.scrollToSelectedItem(this.selectedItem)
  },
  methods: {
    formInnerItems: function () {
      const selectedItem = this.selectedItem
      const items = this.items
      const activeAndSelectedItems = items.filter(item => item.active || selectedItem != null && item === selectedItem)

      if (activeAndSelectedItems.length <= 8) {
        this.shownItems = activeAndSelectedItems
        this.groupsCount = 1
        // } else if (activeAndSelectedItems.length <= 16) {
        //   this.shownItems = activeAndSelectedItems
      } else {
        this.shownItems = items
      }

      let index = 0
      const innerItems = []
      for (let j = 0; j < this.groupsCount; j++) {
        for (const item of this.shownItems) {
          innerItems.push({
            selected: !!(selectedItem && selectedItem.value === item.value),
            bold: item.value % 5 === 0,
            item: item,
            index: index,
            key: j + '_' + item.value
          })
          index++
        }
      }
      this.innerItems = innerItems
    },
    scrollToSelectedItem: function (selectedItem) {
      const groupsCount = this.groupsCount
      if (groupsCount != 1) {
        const groupSize = this.shownItems.length
        const centralGroupStartIndex = groupSize * ((groupsCount - 1) / 2) // TODO обработать четный вариант
        const indexToScroll = selectedItem ? centralGroupStartIndex + selectedItem.value : centralGroupStartIndex
        this.scrollToItem(indexToScroll)
      }
    },
    scrollToItem: function (indexToScroll) {
      const itemHeight = 32 // !
      const pixelToScroll = indexToScroll * itemHeight // centralGroupStartPixel

      this.$refs.list.$el.scrollTo({
        top: pixelToScroll,
        left: 0,
        behavior: 'instant'
      })
    },
    onItemClick: function (item) {
      if (item.active) {
        this.lastClickedItem = item
        this.$emit('select', item)
      }
    },
    onItemKeyDown: function (event, innerItem) {
      if (event.code === 'ArrowLeft' || event.code === 'ArrowRight') {
        this.$emit('item-keydown', event)
      } else if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault()

        let nextIndex = null
        if (event.code === 'ArrowUp') {
          nextIndex = innerItem.index - 1
        } else if (event.code === 'ArrowDown') {
          nextIndex = innerItem.index + 1
        }

        this.focusInnerItem(nextIndex)
      } else if (event.code === 'Enter') {
        if (!innerItem.selected) {
          // Если данным нажатием происходит выбор значения, то останавливаем событие, чтобы надатие не воспринималось как подтверждение ввода всего значения и попап не закрылся
          event.preventDefault()
          event.stopPropagation()
        }
      }
    },

    // @Public
    focusSelectedItem: function () {
      const selectedItem = this.selectedItem
      const focusValue = selectedItem ? selectedItem.value : 0
      let focusIndex
      const groupsCount = this.groupsCount
      if (groupsCount != 1) {
        const groupSize = this.shownItems.length
        focusIndex = groupSize * ((groupsCount - 1) / 2) + focusValue
      } else {
        focusIndex = focusValue
      }

      this.focusInnerItem(focusIndex)
      // При фокусировке скролл происходит сам, выбранный элемент располагается в середине области
    },
    focusInnerItem: function (index) {
      if (index != null && index >= 0 && index < this.innerItems.length) {
        // const nextInnerItem = this.innerItems[nextIndex]
        const nextElement = this.$refs.list.$el.children[index]
        if (nextElement) {
          nextElement.focus()
        }
      }
    }
  }
}

